import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const networkTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Network',
  key: 'NETWORK',
  main: {
    metadata: {
      layout: {
        rows: [
          [
            'id',
          ],
          [
            'interface',
          ],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      interface: {
        label: 'Name of Network Interface',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 16,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
    },
  },
};
